import React from "react";
import { FINGER, fingerFor } from "@/components/FingerKeyboard";

// finger geometry for a left hand; right hand is mirrored
const FINGERS = [
  { name: "pinky", x: 2, y: 20, h: 22 },
  { name: "ring", x: 12, y: 10, h: 32 },
  { name: "middle", x: 22, y: 4, h: 38 },
  { name: "index", x: 32, y: 10, h: 32 },
  { name: "thumb", x: 44, y: 34, h: 18 },
];

export function PixelHands({ nextChar, size = 64, children, restKeys }) {
  const t = fingerFor(nextChar);
  const active = (hand) => {
    if (restKeys) {
      return restKeys.map(fingerFor).filter((r) => r && r.hand === hand).map((r) => r.finger);
    }
    if (!t) return [];
    const list = [];
    if (t.hand === hand || t.hand === "both") list.push(t.finger);
    if (t.shift && t.hand !== hand) list.push("pinky");
    return list;
  };
  return (
    <div className="flex items-end gap-3" data-testid="pixel-hands">
      <Hand side="left" active={active("left")} size={size} wiggle={!restKeys} />
      {children}
      <Hand side="right" active={active("right")} size={size} wiggle={!restKeys} />
    </div>
  );
}

function Hand({ side, active, size, wiggle }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 56 60"
      shapeRendering="crispEdges"
      data-testid={`hand-${side}`}
      data-active={active.join(",")}
      style={side === "right" ? { transform: "scaleX(-1)" } : undefined}
    >
      <rect x="2" y="40" width="40" height="18" fill="#2a2748" stroke="#4a4680" strokeWidth="2" />
      {FINGERS.map((f) => {
        const on = active.includes(f.name);
        return (
          <rect
            key={f.name}
            className={on && wiggle ? "tb-finger-wiggle" : ""}
            data-finger={f.name}
            x={f.x}
            y={f.y}
            width="8"
            height={f.h}
            fill={on ? FINGER[f.name] : "#2a2748"}
            stroke={on ? FINGER[f.name] : "#4a4680"}
            strokeWidth="2"
            style={on ? { filter: `drop-shadow(0 0 4px ${FINGER[f.name]})` } : undefined}
          />
        );
      })}
    </svg>
  );
}
